export const WidePhoto = { width: 210, height: 157 };
export const TallPhoto = { width: 157, height: 210 };
export const SquarePhoto = { width: 157, height: 157 };

const allPhotos =  {
    WidePhoto,
    TallPhoto,
    SquarePhoto
}

export default allPhotos;